/* eslint quotes: "off" */
const frCA = {
  common: {
    ok: "OK!",
    oops: "Oups!",
    cancel: "Annuler",
    back: "Retour",
    email: "Courriel",
    name: "Nom",
    done: "Terminé",
    optional: "Optionnel",
    next: "Suivant",
    apply: "Appliquer",
    add: "Ajouter",
    edit: "Modifier",
    save: "Enregistrer",
    view: "Voir",
    error: "Erreur",
    loading: "Chargement...",
    submit: "Soumettre",
    confirm: "Confirmer",
    discardChanges: "Annuler les modifications",
    skip: "Passer",
    yes: "Oui",
    no: "Non",
    you: "Vous",
    openCruisenApp: "Ouvrir Cruisen",
  },
  forceUpdate: {
    title: "Mise à jour requise",
    body: "Une nouvelle version de l'application est disponible. Veuillez mettre à jour pour continuer à utiliser l'application.",
    updateNow: "Mettre à jour maintenant",
  },
  screenList: {
    readyForLaunch: "Liste des écrans",
    exciting: "(appuyez sur un bouton pour naviguer)",
  },
  loginScreen: {
    sentMagicLink: "Vous avez reçu un courriel!",
    inviteText: "vous a invité à leur croisière! Entrez votre courriel pour vous joindre.",
    clickTheLink:
      "Nous vous avons envoyé un lien magique de connexion. Appuyez sur le bouton dans votre courriel pour vous connecter automatiquement. Cela peut prendre quelques minutes pour arriver.",
    confirmationCodeInEmail:
      "Veuillez entrer le code de confirmation que vous avez reçu à votre adresse courriel. Cela peut prendre quelques minutes pour arriver.",
    openMailApp: "Ouvrir l'application de courriel",
    resendEmail: "Renvoyer le courriel",
    openEmailTitle: "Lien de connexion envoyé",
    openEmailError: "Impossible d'ouvrir le client de messagerie par défaut.",
    resentLoginEmail: "Nous vous avons envoyé un autre lien de connexion!",
    resending: "Renvoi en cours...",
    loggingIn: "Connexion en cours...",
    enterEmailError: "Veuillez entrer à nouveau votre courriel",
    accountRemoval: "Suppression du compte",
    accountRemovalMessage:
      "Nous avons reçu la demande de suppression de votre compte. La suppression de vos données du système peut prendre jusqu'à 5 jours ouvrables. Merci d'avoir été client de Cruisen.",
    enterConfirmationCode: "Entrez le code de confirmation",
  },
  ahoyScreen: {
    ahoy: "Ohé!",
    welcomeToCruisen:
      "Bienvenue sur Cruisen, la façon la plus simple de réserver une croisière – point final.",
  },
  onboardingScreen: {
    next: "Suivant",
    getCruising: "Commencez à naviguer!",
    createTrip: {
      title: "Créez votre voyage idéal",
      description:
        "Définissez simplement la région d'où vous souhaitez partir en croisière, choisissez une ou deux destinations et dites-nous quand vous souhaitez partir en croisière.",
    },
    rallyCrew: {
      title: "Rassemblez votre équipage",
      desciption:
        "Invitez vos amis, votre famille et vos premiers compagnons. Ajoutez et organisez tout le monde dans leurs chambres respectives pour le voyage.",
    },
    bookCruise: {
      title: "Réservez la croisière parfaite",
      description:
        "Parcourez une sélection incroyable de croisières, parfaitement adaptées à vous et votre équipage.",
    },
    navigator: {
      title: "Besoin d'aide?",
      description:
        "Demandez conseil à notre Navigateur alimenté par l'IA pour votre voyage, ou obtenez l'aide d'un conseiller personnalisé.",
    },
    loyaltyProgram: {
      title: "Gagnez des points",
      description:
        "Soyez récompensé pour la création d'un voyage, l'invitation de vos amis et la réservation avec Cruisen.",
    },
  },
  registerScreen: {
    introduceYourself: "Présentez-vous",
    addPhoto: "Ajouter une photo",
    changePhoto: "Changer la photo",
    basicDetails: "Informations de base",
    firstName: "Prénom*",
    lastName: "Nom de famille*",
    ageGroup: "Groupe d'âge*",
    phoneNumber: "Numéro de téléphone*",
    referralCode: "Code de parrainage",
    emailAddress: "Adresse courriel",
    setSail: "Lever l'ancre",
    chooseOption: "Choisissez une option",
    takePhoto: "Prendre une photo",
    chooseFromLibrary: "Choisir dans la bibliothèque",
    errors: {
      failedToCreateUser:
        "Oups! Une erreur s'est produite lors de l'enregistrement de votre profil. Veuillez vérifier votre connexion Internet et réessayer!",
      failedToUploadAvatar:
        "Oups! Une erreur s'est produite lors du téléchargement de votre avatar. Veuillez vérifier votre connexion Internet et réessayer, ou sélectionner une autre photo.",
      phoneNumberTitle: "Numéro de téléphone invalide",
      phoneNumberDescription:
        "Veuillez entrer un numéro de téléphone valide, comme (123) 456-7890.",
    },
  },
  tripCreation: {
    title: "Créer un voyage",
    nameYourTrip: "Nommez votre voyage*",
    sailingFrom: "Départ de*",
    sailingTo: "Destination",
    travelDates: "Mois de départ*",
    createTrip: "Créer le voyage",
    cruisesCount: "Croisières trouvées: %{cruisesCount}",
    errors: {
      tripNameTitle: "Nom du voyage trop long",
      tripNameDescription: "Le nom du voyage ne peut pas dépasser 25 caractères",
    },
  },
  tripOverview: {
    departing: "Départ %{locations}",
    to: "Navigation vers %{locations}",
    locations: "%{amount} destinations",
    cruises: "CROISIÈRES",
    cruise: "CROISIÈRE",
    showAll: "Tout afficher",
    crew: "Chambres",
    invite: "Inviter",
    assignedAgent: "Agent de voyage assigné:",
    tripAdvisor: "Conseiller de voyage",
    tags: {
      agentPick: "Choix de l'agent",
      priceDrop: "Baisse de prix",
    },
    searchingCruises: "Recherche de croisières...",
    inviteTextMessage:
      '%{invitingUser} vous a invité à rejoindre le voyage "%{tripName}" sur l\'application Cruisen',
    addRoom: "Ajouter une chambre",
    deleteRoom: "Supprimer la chambre",
    bookRoom: "Réserver la chambre",
    noCruisesFound: "Aucune croisière trouvée",
    emptyCruisesListMessage:
      "Nous n'avons trouvé aucune croisière pour ces dates à ce port. Essayez de mettre à jour votre recherche.",
    changeSearchCriteria: "Veuillez modifier vos critères de recherche",
    changeDates: "Changer les dates",
    changePort: "Changer de port",
    roomOptions: "Options de chambre",
    addGuest: "Ajouter un invité",
    addProfileGuest: "Ajouter le profil comme invité",
    pickProfile: "Choisir un profil",
    changeName: "Changer le nom",
    guestOptions: "Options d'invité",
    unassigned: "Non assigné",
    unassignedActionText: "Rejoignez une chambre pour être inclus dans la réservation",
    joinRoom: "Rejoindre la chambre",
    bringEveryone: "Organisez votre équipage.",
    showMorePorts: "Afficher %{amount} ports de plus",
    sortBy: "Trier par",
    filters: "Filtres",
    tabTitles: {
      navigator: "Navigateur",
      cruises: "Croisières",
      crew: "Chambres",
    },
    sortingLabels: {
      date: "Date",
      durationShortToLong: "Durée (plus courte à plus longue)",
      durationLongToShort: "Durée (plus longue à plus courte)",
      mostLiked: "Les plus aimées",
      priceByLowest: "Prix (bas à élevé)",
      priceByHighest: "Prix (élevé à bas)",
    },
  },
  cruiseFilteringModal: {
    reset: "Réinitialiser",
    ports: "Ports",
    filterBy: "Filtrer par",
    noFiltersAvailable: "Aucun filtre disponible",
    price: "Prix",
    tagsBoxTitle: "Étiquettes",
    tags: {
      agentPick: {
        name: "Choix de l'agent",
        label: "Afficher uniquement les croisières aimées par l'agent",
      },
      priceDrop: {
        name: "Baisse de prix",
        label: "Prix réduit",
      },
    },
    duration: "Durée",
    ships: "Navires",
    shipLaunchYear: "Année de lancement du navire",
    cruiseLines: "Compagnies de croisière",
    matchingCruisesCount: "%{amount} croisières correspondantes",
    done: "Terminé",
    days: "%{amount} Jours",
  },
  addGuestModal: {
    pickProfile: "Choisir un profil",
    requiredFirstName: "Prénom*",
    requiredLastName: "Nom de famille*",
    requiredAgeGroup: "Groupe d'âge*",
    requiredDateOfBirth: "Date de naissance*",
    email: "Courriel",
    phoneNumber: "Numéro de téléphone",
    addGuest: "Ajouter un invité",
    fillFirstAndLastNameError:
      "Vous devez remplir le groupe d'âge, le prénom et le nom de famille de l'invité",
  },
  editGuestModal: {
    editGuest: "Modifier l'invité",
  },
  guestOptionsModal: {
    fixDob:
      "Les invités mineurs doivent fournir leur date de naissance. Veuillez mettre à jour cet invité.",
    editDetails: "Modifier les détails",
    removeGuest: "Retirer l'invité",
  },
  changeRoomDetailsModal: {
    shortTitle: "Modifier les détails",
    title: "Modifier les détails de la chambre",
    roomNamePlaceholder: "Nom de la chambre",
    submitButton: "Mettre à jour les détails",
    fillRoomName: "Vous devez remplir le nom de la chambre",
    errors: {
      roomName: "Le nom de la chambre ne peut pas dépasser 20 caractères",
    },
  },
  addRoomModal: {
    title: "Ajouter une chambre",
    requiredRoomName: "Nom de la chambre*",
    cabinTypePreference: "Préférence de type de cabine",
    cabinTypePlaceholder: "Aucune préférence",
    submitButton: "Ajouter la chambre",
  },
  deleteRoomModal: {
    title: "Supprimer la chambre",
    warning: "La suppression de la chambre déplacera tous les invités vers non assignés",
    submitButton: "Confirmer",
  },
  cruiseSuggestionCard: {
    perPerson: "/pp",
    upperCaseDeal: "OFFRE",
    wasOn: "était %{price}",
    for: "pour",
    noCabinsAvailable: "Aucune cabine disponible",
    view: "Voir",
    tags: {
      lastOne: "Dernière disponible",
    },
  },
  bookedCruiseCard: {
    from: "De",
    to: "À",
    book: "Réserver",
    view: "Voir",
    ports: "%{amount} ports",
    daysAndNights: "%{daysAmount} jours, %{nightsAmount} nuits",
    viewItinerary: "Voir l'itinéraire",
  },
  roomCard: {
    deck: "Pont",
    cabin: "Cabine",
    leaveRoom: "Quitter la chambre",
    join: "Rejoindre",
    addGuest: "Ajouter un invité",
    changeName: "Changer le nom",
  },
  monthPicker: {
    dates: "Mois de départ",
    loadingDates: "Les mois de destination surfent sur les vagues. Patientez!",
    datesUnavailable: "Certaines des dates sélectionnées ne sont pas disponibles",
    clearUnavailableDates: "Effacer les mois non disponibles",
  },
  portPicker: {
    searchOrigin: "Rechercher une origine",
    searchDestination: "Rechercher une destination",
    originPorts: "Ports d'origine",
    destinationPorts: "Ports de destination",
    portsLoading: "Les données des ports surfent sur les vagues. Patientez!",
    noResults: "Aucun résultat",
    tryEditingYourSearch: "Essayez de modifier votre recherche",
    pickDeparturePort:
      "Pour les ports de destination, choisissez d'abord au moins un port de départ!",
  },
  errorAlert: {
    default: {
      title: "Oups!",
    },
    email: {
      title: "Adresse courriel invalide",
      content: "Veuillez réessayer.",
    },
  },
  errorScreen: {
    title: "Quelque chose s'est mal passé!",
    friendlySubtitle:
      "Ceci est l'écran que vos utilisateurs verront en production lorsqu'une erreur survient. Vous voudrez personnaliser ce message (situé dans `app/i18n/en.ts`) et probablement la mise en page aussi (`app/screens/ErrorScreen`). Si vous voulez le supprimer complètement, vérifiez `app/app.tsx` pour le composant <ErrorBoundary>.",
    reset: "RÉINITIALISER L'APPLICATION",
  },
  inviteModal: {
    heading: "Amenez tout le monde",
    contentDisabledLoyalty:
      "Envoyez simplement une invitation pour ajouter d'autres personnes à votre voyage!",
    content:
      "Envoyez simplement une invitation pour ajouter d'autres personnes à votre voyage! Gagnez %{tokenAmount} Points Cruisen pour chaque invitation, jusqu'à %{invitationBonusLimit} personnes.",
    button: "Envoyer une invitation",
    later: "Plus tard",
  },
  globalMenu: {
    paymentMethod: "Mode de paiement",
    trips: "Voyages",
    thirdOption: "Troisième option",
    logOut: "Se déconnecter",
    accountSettings: "Paramètres du compte",
    deleteAccount: {
      title: "Supprimer le compte",
      warning:
        "Êtes-vous sûr de vouloir supprimer votre compte? Cela supprimera définitivement toutes les informations personnelles et les données du compte et ne peut pas être annulé.",
    },
  },
  globalMenuScreen: {
    viewProfile: "Voir le profil",
    trips: "Voyages",
    loyaltyNumbers: "Numéros de fidélité",
    loyaltyTokens: "Points Cruisen",
    allProfiles: "Tous les profils",
    developerScreen: "Écran développeur",
    inviteToTrip: "Inviter au voyage",
  },
  advisorDetailsModal: {
    advisorDetails: "Détails du conseiller",
    shortBio: "Courte biographie",
    favoriteTravelDestination: "Destination de voyage préférée",
    bestTravelAdvice: "Meilleur conseil de voyage",
    agency: "Agence",
  },
  accountScreen: {
    title: "Vous",
    firstName: "Prénom",
    lastName: "Nom de famille",
    email: "Courriel",
    phoneNumber: "Numéro de téléphone",
    pirateName: "Nom de pirate 🏴‍☠️",
    random: "Aléatoire",
    manageAccount: "Gérer le compte",
    logout: "Se déconnecter",
    deleteAccount: "Supprimer le compte",
    unsavedTitle: "Modifications non enregistrées",
    unsavedMessage: "Êtes-vous sûr de vouloir annuler toutes les modifications du compte?",
  },
  invitationScreen: {
    title: "vous a invité à leur voyage!",
    joinTrip: "Rejoindre le voyage",
    declineInvite: "Refuser l'invitation",
    inviteMessage: "Vous avez été invité à Cruisen, inscrivez-vous maintenant!",
    signUp: "S'inscrire",
  },
  tripListScreen: {
    title: "Voyages",
    guests: "%{amount} invités",
    noCruiseSelected: "Aucune croisière sélectionnée",
    newTrip: "Nouveau voyage",
  },
  cruiseDetailsScreen: {
    decks: "Ponts",
    trip: "Le voyage",
    ship: "Le navire",
    day: "Jour %{day} · %{date}",
    viewFullTrip: "Voir le voyage complet",
    perPerson: "/pp",
    select: "Sélectionner",
    showMore: "Afficher plus",
    whatsIncluded: "Ce qui est inclus",
    cabins: "Cabines",
    noCabinsAvailable: "Aucune cabine disponible",
    startingFrom: "À partir de",
    showDetails: "Afficher les détails",
    cabinTypeDetails: "Détails du type de cabine",
    cabinImageUnavailable: "Image de cabine non disponible",
    setPreferredCruise: "Sauvegarder pour plus tard",
    unsetPreferredCruise: "Sauvegardé pour plus tard",
    preferredCruiseDetails:
      "Sauvegardez cette croisière comme celle que vous et vos invités avez l'intention de réserver plus tard.",
    errors: {
      failedToLoad:
        "Oups! Une erreur s'est produite lors du chargement des détails de la croisière. Veuillez vérifier votre connexion Internet et réessayer!",
    },
  },
  roomLayout: {
    adult: "adulte",
    adults: "adultes",
    child: "enfant",
    children: "enfants",
  },
  tripDetails: {
    anytime: "N'importe quand",
    anywhere: "N'importe où",
    anyport: "N'importe quel port",
    months: "mois",
    anyportIn: "N'importe quel port dans %{group}",
    anyportInLocations: "N'importe quel port dans %{amount} destinations",
    anyportFrom: "N'importe quel port de %{group}",
    anyportFromLocations: "N'importe quel port de %{amount} destinations",
    locations: "%{amount} destinations",
  },
  imageError: {
    generic: "L'image n'est pas disponible",
    cabin: "L'image de la cabine n'est pas disponible",
    cruise: "L'image de la croisière n'est pas disponible",
  },
  navigatorSystemMessageComponents: {
    createTripWelcomeOne:
      "Bonjour %{userFirstName} 👋 Bienvenue sur Cruisen! Je suis Navigator, votre assistant IA dédié. Je suis là pour vous guider dans votre réservation de croisière.",
    createTripWelcomeTwo:
      "La première étape pour réserver votre croisière de rêve est d'ajouter vos chambres et invités dans l'onglet \"Chambres\".",
    createTripWelcomeThree:
      'Si vous avez besoin de conseils, n\'hésitez pas à "Demander à Navigator", ou vous pouvez essayer "Obtenir un conseiller" pour une assistance plus personnalisée.',
    joinTripWelcomeOne:
      "Bonjour %{userFirstName}! Bienvenue à bord de l'aventure d'une vie. Je suis Navigator, votre assistant IA dédié. Je suis là pour vous guider dans votre réservation de croisière.",
    joinTripWelcomeTwo:
      'Si vous avez besoin de conseils, n\'hésitez pas à "Demander à l\'IA", ou vous pouvez essayer "Obtenir un conseiller" pour une assistance plus personnalisée.',
    viewTutorial: "Comment réserver une croisière",
    cruiseBooked: "Voir la croisière réservée",
    cruiseResultsReady: "Plongez dans les résultats de croisière 🏊‍♂️",
    cruiseBookedDates: "Dates de navigation: ",
    viewCruise: "Voir la croisière",
    viewCruises: "Voir les croisières",
    viewRooms: "Voir les chambres",
    addGuests: "Ajouter des invités",
    exploreMore: "Explorer plus",
    userBookedCabin: "%{authorName} a réservé une cabine! 🎉",
    bookNearby: "Réserver à proximité",
    departingFrom: "Départ de %{port}",
    cabinNumber: "Cabine #%{cabinNo}",
    preferredCruiseSet: "%{authorName} a sauvegardé cette croisière pour réserver plus tard.",
    sailingTo: "Navigation vers: ",
    departing: "Départ: ",
    dates: "Mois de départ: ",
    anyPort: "N'importe où",
    multiplePorts: "Plusieurs sélectionnés",
    recommendedDeck: "Vérifiez les cabines au %{deckName} pour votre équipage",
    navigatorCruiseRecommendation: "Croisière %{cruiseSailingName} partant le %{date}.",
    savedCabin: {
      singleCabin: "%{authorName} a sauvegardé la Cabine %{cabinNo} pour %{roomName}",
      multipleCabins: "%{authorName} a sauvegardé %{cabinAmount} cabines:",
      cabinSaved: "Cabine %{cabinNo} pour %{roomName}",
    },
  },
  navigator: {
    name: "Navigator",
    askAQuestion: "Demander de l'aide",
    messageCrew: "Message au groupe",
    message: "Message",
    askAI: "Demander à l'IA",
    askNavigator: "Poser une question à Navigator",
    contactAdvisor: "Obtenir un conseiller",
    delayInfo:
      "Nos heures de clavardage en direct sont du lundi au vendredi de 10h à 18h HNE, les réponses peuvent être retardées.",
    getHelp: {
      button: "Contacter Cruisen",
      title: "Contacter un conseiller",
      emailSubject: "Aide pour le voyage: %{title} (#%{id})",
      contentStart:
        "Nous sommes désolés que vous rencontriez des difficultés. Veuillez nous envoyer un courriel à ",
      contentEnd:
        " pour obtenir de l'aide. Soyez assuré que nous répondrons pendant les heures de bureau dans les 2 jours ouvrables.",
    },
    error:
      "Nous rencontrons actuellement des problèmes de connectivité avec Navigator, veuillez réessayer plus tard. Merci de votre patience!",
    you: "Vous",
    fromCruisen: "Conseiller Cruisen",
    userLikedCruise: "%{author} a aimé une croisière.",
    userLikedCruises: "%{author} a aimé des croisières.",
  },
  tripEdition: {
    title: "Modifier le voyage",
    edit: "Modifier",
  },
  ageGroups: {
    infant: {
      label: "Bébé",
      range: "(moins de 2 ans)",
    },
    child: {
      label: "Enfant",
      range: "(2-17 ans)",
    },
    adult: {
      label: "Adulte",
      range: "(18 ans et plus)",
    },
  },
  cabinTypes: {
    inside: "Intérieure",
    outside: "Extérieure",
    balcony: "Balcon",
    suite: "Suite",
  },
  cabinBookingCard: {
    deck: "Pont %{deckNo}",
    cabin: "Cabine %{cabinNo}",
    change: "Modifier",
    totalAmount: "Montant total",
    cabinTotal: "Total de la cabine",
    checkingCabinAvailability: "Vérification de la disponibilité de la cabine",
    changeCabin: "Veuillez changer de cabine pour continuer",
    checkBookingDetailsAndTryAgain:
      "Veuillez vérifier les détails des passagers et du paiement, puis réessayer",
    booked: "Réservé",
    diningOptions: "Options de repas",
    chooseDiningOption: "Choisir l'option de repas",
  },
  cabinDetails: {
    roomDetails: "Détails de la chambre",
    totalAmount: "Montant total",
  },
  shipDetails: {
    launched: "Lancé",
    occupancy: "Capacité",
  },
  cabinsFiltering: {
    filterCabins: "Filtrer les cabines",
    samePrice: "Toutes les cabines sur ce pont ont le même prix: %{price}",
    cabinTypes: "Types de cabine",
    errorTitle: "Le filtrage des cabines n'est pas disponible actuellement",
    errorDescription: "Nous nous excusons pour le désagrément. Veuillez réessayer plus tard.",
    matchingCabins: "%{amount} cabines correspondantes sur ce pont",
    matchingDecks: "%{amount} ponts avec des cabines appropriées",
  },
  deckSelection: {
    selectDeck: "Sélectionner un pont",
    from: "À partir de",
    matchingDecks: "Ponts correspondant à vos filtres",
    notMatchingDecks: "Ponts ne correspondant pas à vos filtres",
    soldOut: "Complet",
  },
  cabinSelectionSummary: {
    cabins: "Cabines",
    changeCabins: "Changez de cabines pour continuer",
    checkingCabinAvailability: "Vérification de la disponibilité des cabines",
    continueToPayment: "Continuer vers le paiement",
    settingUpPayment: "Configuration de votre paiement...",
    fillPaymentDetails: "Détails de paiement requis",
    fillDiningOptions: "Option de repas requise",
    fillContactDetails: "Coordonnées requises",
    fillPassengersInfo: "Informations des passagers requises",
    bookAndPay: "Réserver et payer",
    noOptionSelected: "Aucune option sélectionnée",
    selectedPaymentMethod: "Mode de paiement sélectionné",
    paymentDetailsUppercased: "DÉTAILS DU PAIEMENT",
  },
  cruiseBooking: {
    roomSelection: "Sélection de la chambre",
    cabinType: "Type de cabine",
    selectCabin: "Sélectionner une cabine",
    cabin: "Cabine %{cabinNo}",
    room: "Chambre",
    pay: "Payer",
    summary: "Résumé",
    payment: "Paiement",
    selected: "%{amount} sélectionné",
    decks: "Ponts",
    cabinBooked: "cabine réservée",
    cabinsBooked: "cabines réservées",
    loadingCabinsError:
      "Nous n'avons pas pu charger les cabines pour ce pont. Réessayez plus tard ou choisissez un autre pont.",
    whichGroupBooking: "Pour quels groupes réservez-vous?",
    bookCruise: "Réserver la croisière",
    bookingLoading: "Réservation en cours...",
    findingCabins: "Recherche de disponibilités...",
    preparingCabins: "Préparation des cabines...",
    lookingForPerfectFit: "Veuillez patienter, cela peut prendre un moment",
    cabinsNoneFoundYet: "Aucune cabine trouvée pour l'instant",
    cabinsFound: "%{amount} cabines trouvées",
    noCabinsAvailable: "Aucune cabine disponible pour cette croisière",
    backToCruises: "Retour à la liste des croisières",
    noCabinsMatchFilters: "Aucune cabine ne correspond à vos filtres sur ce pont",
    clearFilters: "Effacer les filtres",
    changeDeck: "Changer de pont",
    deckImageError: "Nous n'avons pas pu charger l'image du pont, veuillez réessayer plus tard.",
    goBackToCruiseDetails: "Aller aux détails de la croisière",
    loyaltyTokens: {
      useloyaltyTokens: "Utiliser les Points Cruisen",
      availablePoints: "%{amount} disponibles",
      applyPoints: "Appliquer les points",
      firstBookingInfo:
        "Vous pouvez appliquer jusqu'à %{loyaltyTokensBookingCap} Points Cruisen (%{bookingCap}% de %{cruisePrice} avant taxes et frais) sur votre première réservation.",
      tripSubtotal: "Sous-total du voyage",
      tax: "Taxes et frais",
      tripTotal: "Total du voyage",
      total: "Total",
      loyaltyTokens: "Points Cruisen",
      bookingEarnings: "Vous gagnerez %{amount} Points Cruisen pour cette réservation.",
    },
    errors: {
      unknown: "Échec de la réservation. Veuillez contacter le support",
      basketNotFound: "Échec de la réservation. Veuillez contacter le support",
      cabinUnavailable: "La cabine n'est plus disponible",
      roomHasBookedCabin: "La chambre a déjà une cabine réservée",
    },
  },
  passengerDetailsModal: {
    title: "Titre",
    mr: "M.",
    ms: "Mme",
    mrs: "Mme",
    miss: "Mlle",
    passengerDetails: "Informations du passager",
    passengerDetailsWithName: "Informations de %{name}",
    primarySailorResidence: "Utiliser ma résidence",
    enterValidPostcode: "Veuillez entrer un code postal valide, comme 12345",
  },
  fixBookingData: {
    title: "Entrer les informations requises",
    provideInformationForChild: "Veuillez fournir la date de naissance de vos enfants.",
  },
  bookingPassengers: {
    roomInfo: "%{roomName} | Cabine %{cabinNo}",
    addInfo: "Ajouter",
    sailorInfo: "Informations du passager",
    contactDetailsUppercased: "COORDONNÉES",
    fillContactDetails: "Remplir les coordonnées",
  },
  creditCardForm: {
    fillDetails: "Détails du paiement",
    holder: "Nom du titulaire",
    cardNumber: "Numéro de carte",
    expiry: "Date d'expiration",
    cvcCode: "CVC",
    editDetails: "Modifier les détails",
    addDetails: "Ajouter les détails",
    addCreditCardDetails: "Ajouter les détails de la carte de crédit",
    creditCardDetails: "Détails de la carte de crédit",
    creditCardCVCExpiredNotice: "Veuillez mettre à jour le CVC de la carte de crédit",
  },
  profileScreen: {
    profiles: "Profils",
    primary: "Principal",
    addProfile: "Ajouter un profil",
    sailors: "passagers",
    nights: "nuits",
    itineraryDetails: "Détails de l'itinéraire",
    roomType: "Type de chambre",
    primarySailor: "Passager principal",
    personalInfoPermission:
      "Vos informations personnelles seront utilisées uniquement à des fins de réservation.",
    countryPicker: {
      searchCountry: "Rechercher un pays",
      noCountryLeft: "Il n'y a plus de pays, veuillez modifier votre recherche",
    },
    statePicker: {
      searchState: "Rechercher un état",
      noStateLeft: "Il n'y a plus d'états, veuillez modifier votre recherche",
      states: {
        al: { code: "AL", name: "Alabama" },
        ak: { code: "AK", name: "Alaska" },
        az: { code: "AZ", name: "Arizona" },
        ar: { code: "AR", name: "Arkansas" },
        ca: { code: "CA", name: "Californie" },
        co: { code: "CO", name: "Colorado" },
        ct: { code: "CT", name: "Connecticut" },
        de: { code: "DE", name: "Delaware" },
        dc: { code: "DC", name: "District de Columbia" },
        fl: { code: "FL", name: "Floride" },
        ga: { code: "GA", name: "Géorgie" },
        hi: { code: "HI", name: "Hawaii" },
        id: { code: "ID", name: "Idaho" },
        il: { code: "IL", name: "Illinois" },
        in: { code: "IN", name: "Indiana" },
        ia: { code: "IA", name: "Iowa" },
        ks: { code: "KS", name: "Kansas" },
        ky: { code: "KY", name: "Kentucky" },
        la: { code: "LA", name: "Louisiane" },
        me: { code: "ME", name: "Maine" },
        md: { code: "MD", name: "Maryland" },
        ma: { code: "MA", name: "Massachusetts" },
        mi: { code: "MI", name: "Michigan" },
        mn: { code: "MN", name: "Minnesota" },
        ms: { code: "MS", name: "Mississippi" },
        mo: { code: "MO", name: "Missouri" },
        mt: { code: "MT", name: "Montana" },
        ne: { code: "NE", name: "Nebraska" },
        nv: { code: "NV", name: "Nevada" },
        nh: { code: "NH", name: "New Hampshire" },
        nj: { code: "NJ", name: "New Jersey" },
        nm: { code: "NM", name: "Nouveau-Mexique" },
        ny: { code: "NY", name: "New York" },
        nc: { code: "NC", name: "Caroline du Nord" },
        nd: { code: "ND", name: "Dakota du Nord" },
        oh: { code: "OH", name: "Ohio" },
        ok: { code: "OK", name: "Oklahoma" },
        or: { code: "OR", name: "Oregon" },
        pa: { code: "PA", name: "Pennsylvanie" },
        ri: { code: "RI", name: "Rhode Island" },
        sc: { code: "SC", name: "Caroline du Sud" },
        sd: { code: "SD", name: "Dakota du Sud" },
        tn: { code: "TN", name: "Tennessee" },
        tx: { code: "TX", name: "Texas" },
        ut: { code: "UT", name: "Utah" },
        vt: { code: "VT", name: "Vermont" },
        va: { code: "VA", name: "Virginie" },
        wa: { code: "WA", name: "Washington" },
        wv: { code: "WV", name: "Virginie-Occidentale" },
        wi: { code: "WI", name: "Wisconsin" },
        wy: { code: "WY", name: "Wyoming" },
      },
    },
    form: {
      passengerDetails: "Détails du profil",
      passengerResidence: "Résidence",
      firstName: "Prénom*",
      lastName: "Nom de famille*",
      dateOfBirth: "Date de naissance",
      dateOfBirthRequired: "Date de naissance*",
      nationality: "Citoyenneté",
      address: "Adresse",
      state: "État",
      postcode: "Code postal",
      country: "Pays",
      city: "Ville",
      submit: "Soumettre",
    },
  },
  loyaltyProgram: {
    title: "Points Cruisen",
    totalAvailablePoints: "Total des points disponibles",
    pendingPoints: "Points en attente",
    history: "Historique",
    infoModal: {
      title: "Que sont les Points Cruisen?",
      description: "Et comment puis-je les obtenir?",
      introduction:
        "Voici les Points Cruisen, notre programme de fidélité conçu pour vous récompenser de naviguer avec nous! Voici comment vous pouvez gagner et utiliser vos points:",
      earn: "Gagner",
      cruisenPoints: "Points Cruisen",
      signUp: "Inscription: Obtenez %{amount} points simplement en vous inscrivant.",
      inviteFriends:
        "Inviter des amis: Gagnez %{amount} points pour chaque ami invité (jusqu'à %{limit} amis).",
      bookCruise:
        "Réserver une croisière: Gagnez %{amount}% de points pour chaque dollar dépensé sur les tarifs commissionnables.",
      usePoints: "Utiliser vos points",
      firstBooking:
        "Première réservation: Échangez jusqu'à %{amount}% du total de la réservation avant taxes.",
      subsequentBookings:
        "Réservations suivantes: Échangez jusqu'à %{amount}% du total de la réservation.",
      trackPoints:
        "Suivez vos points dans l'application et profitez au maximum de votre expérience Cruisen.",
    },
    historyItem: {
      influencerInvitation: "Inscription Cruisen",
      userJoined: "Inscription Cruisen",
      userInvitation: "%{invitedUserFirstName} %{invitedUserLastNameInitial}. a rejoint Cruisen",
      booking: "Réservation d'une cabine",
      manualBonus: "Bonus de Cruisen",
    },
  },
  cabinTypesDescriptions: {
    cabinTypesOverview: "Aperçu des types de cabines",
    inside: "Intérieure",
    insideDescription:
      "Les cabines intérieures sont compactes et économiques, conçues pour le confort et l'utilité, idéales pour ceux qui préfèrent passer leurs journées à explorer les installations du navire. Ces cabines offrent un sanctuaire confortable pour se reposer après une journée remplie d'activités.",
    outside: "Extérieure",
    outsideDescription:
      "Les cabines extérieures offrent l'avantage supplémentaire d'une fenêtre ou d'un hublot, laissant entrer la lumière naturelle et les vues sur l'océan ou les destinations. Cette option combine le confort des hébergements standard avec le plaisir d'une vue extérieure.",
    balcony: "Balcon",
    balconyDescription:
      "Les cabines avec balcon étendent votre espace privé à l'extérieur, vous permettant de profiter de vues personnelles sur la mer et d'air frais depuis le confort de votre chambre. Elles offrent un équilibre entre le luxe de l'espace et le plaisir de votre propre espace extérieur.",
    suite: "Suite",
    suiteDescription:
      "Les suites sont le summum de l'hébergement en croisière, offrant des espaces de vie spacieux, des commodités améliorées et souvent un accès exclusif à des services spécialisés. Elles offrent une retraite opulente pour ceux qui recherchent le summum du confort et de l'exclusivité pendant leur voyage.",
  },
  emptyStateComponent: {
    generic: {
      heading: "Si vide... si triste",
      content:
        "Aucune donnée trouvée pour l'instant. Essayez de cliquer sur le bouton pour actualiser ou recharger l'application.",
      button: "Essayons à nouveau",
    },
  },
  agentFunctions: {
    recommendCruise: {
      cruisesFound:
        "J'ai trouvé des croisières qui correspondent à votre recherche. Appuyez sur les liens que j'ai envoyés pour voir plus de détails.",
      noCruisesFound:
        "Désolé, je n'ai pas trouvé de croisière correspondant à votre recherche. Veuillez modifier votre recherche et n'oubliez pas d'être très précis. Vous pouvez également aller dans l'onglet \"Croisières\" pour rechercher et filtrer manuellement les croisières.",
      noParams:
        "Aucune croisière trouvée : vous devez fournir des détails sur la croisière que vous recherchez.",
    },
    findCruiseLineIds:
      "Identifiants des compagnies de croisière correspondant à la recherche : %{cruiseLineIds}",
    findCruiseShipIds:
      "Identifiants des navires de croisière correspondant à la recherche : %{cruiseShipIds}",
    findCruiseDestinationIds:
      "Identifiants des ports de destination correspondant à la recherche : %{destinationPortIds}, Identifiants des régions de destination correspondant à la recherche : %{destinationRegionIds}",
    findCruiseDepartureIds:
      "Identifiants des ports de départ correspondant à la recherche : %{departurePortIds}",
    cancelCruise:
      'Pour annuler une croisière, veuillez contacter le support en appuyant sur le bouton "Conseiller" et en envoyant un message.',
    getCruiseDetails:
      "Désolé, je ne peux pas fournir plus de détails sur des croisières spécifiques au-delà de ce qui est disponible dans l'application. Veuillez appuyer sur une carte de croisière ou l'un des liens envoyés dans le chat pour voir plus de détails.",
  },
  emails: {
    global: {
      emailSignature: "L'équipe Cruisen",
      unsubscribe: "Se désabonner",
      footerQuote: "Naviguez ensemble. Cruisen",
      help: "Besoin d'aide?",
      contact: "Contacter Cruisen",
    },
    login: {
      subject: "Connectez-vous à Cruisen",
      title: "Bienvenue à bord!",
      body: "Nous avons reçu une demande de connexion à Cruisen avec cette adresse courriel. Appuyez simplement sur le bouton de connexion sur l'appareil où vous avez installé Cruisen pour vous connecter à l'application. Si vous n'avez pas demandé ce lien, vous pouvez ignorer ce courriel en toute sécurité.",
      bodyWeb:
        "Nous avons reçu une demande de connexion à Cruisen avec cette adresse courriel. Veuillez copier le code de confirmation ci-dessous et le coller dans l'application. Si vous n'avez pas demandé ce code, vous pouvez ignorer ce courriel en toute sécurité.",
      button: "Se connecter",
      confirmationOce: "Code de confirmation",
    },
    booking: {
      subject: "Confirmation de réservation Cruisen",
      title: "Votre croisière est confirmée!",
      yourCruisenBookingNumber: "Votre numéro de réservation Cruisen est ",
      body: "Les détails de votre voyage",
      guestsTitle: "Détails des passagers",
      cruisenBookingNumber: "Numéro de réservation Cruisen",
      cruisenBookingCode: "Code de réservation Cruisen",
      mailingAddress: "Adresse postale",
      bookingCruiseLineReservationCode: "Numéro de réservation de la compagnie de croisière",
      cabinDetailsTitle: "Détails du navire et de la cabine",
      cruiseLine: "Compagnie de croisière",
      cruiseShip: "Navire de croisière",
      cabinNo: "Numéro de cabine",
      deck: "Pont",
      diningArea: "Zone de restauration",
      itineraryTitle: "Votre itinéraire",
      paymentDetailsTitle: "Détails du paiement",
      nameOnCard: "Nom sur la carte",
      lastFourOnCard: "4 derniers chiffres de la carte",
      cardType: "Type de carte",
      expirationDate: "Date d'expiration",
      total: "Total",
      button: "Action",
      loyaltyTokens: "Points Cruisen",
      loyaltyTokensEarned: "Points Cruisen gagnés",
      taxesAndFees: "Taxes et frais",
    },
    marketing: {
      subject: "Nouvelles offres de Cruisen",
      title: "Réservez vos vacances aujourd'hui.",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec neque neque, sagittis et semper elementum.",
      button: "Réserver maintenant",
    },
    serious: {
      subject: "",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec neque neque, sagittis et semper elementum, varius nec mauris.\nPellentesque laoreet lorem massa, vitae suscipit augue ultrices at. Duis mattis massa vitae ante sodales convallis. Pellentesque bibendum quis quam quis bibendum. Maecenas sodales neque in urna fringilla, ac semper dolor cursus.\n Nam finibus, elit vel pretium vulputate, massa mi eleifend velit, at volutpat nunc felis vel libero.\n",
    },
    unreadMessagesReminder: {
      subject: {
        unreadMessages: "Vous avez %{unreadMessagesCount} messages non lus",
        unreadMessagesFromUser:
          "Bonjour %{userFirstName}, vous avez des messages non lus de %{authorFullName}",
        unreadMessagesFromCruisen: "%{authorFullName} de Cruisen vous a envoyé un message",
      },
    },
  },
  validation: {
    useOnlyEnglishLetters: "Seules les lettres anglaises sont autorisées",
  },
  broadcasts: {
    nextMorning: {
      title: "Bonjour, de Cruisen",
      body: "Je suis Reid, le fondateur de Cruisen. Merci d'avoir téléchargé notre application! N'hésitez pas à discuter avec nous à tout moment en appuyant sur \"Conseiller\" ci-dessous, nous sommes là pour rendre votre expérience de réservation Cruisen transparente 😊.",
      buttonText: "Discuter avec nous",
    },
  },
  notifications: {
    welcome: {
      title: "Bienvenue sur Cruisen!",
      body: "%{userFirstName} a créé un nouveau voyage.",
    },
    tripCabinsScanFinished: {
      title: "Analyse des cabines du voyage terminée",
      body: "Analyse des cabines terminée pour toutes les croisières",
    },
    cruiseCabinsScanFinished: {
      title: "Analyse des cabines de croisière terminée",
      body: "%{cruiseSailingName} a %{cabinsAvailable} cabines disponibles à partir de %{lowestPrice}",
    },
    tripRoomCreated: {
      title: "%{userFirstName} %{userLastNameInitial}. a créé %{roomName}",
      body: "%{userFirstName} %{userLastNameInitial}. a créé %{roomName}. N'hésitez pas à rejoindre!",
    },
    tripRoomRenamed: {
      title: "%{userFirstName} %{userLastNameInitial}. a renommé %{oldRoomName} en %{newRoomName}.",
      body: "%{userFirstName} %{userLastNameInitial}. a renommé %{oldRoomName} en %{newRoomName}.",
    },
    userLikedTripSearchResult: {
      title: "%{userFirstName} %{userLastNameInitial}. aime une %{cruiseSailingName}.",
      body: "%{userFirstName} %{userLastNameInitial}. aime une croisière %{cruiseSailingName} partant le %{date} sur %{cruiseSailingLineName}.",
    },
    userSetPreferredCruise: {
      title:
        "%{userFirstName} %{userLastNameInitial}. a sauvegardé %{cruiseSailingName} comme croisière du voyage.",
      body: "%{userFirstName} %{userLastNameInitial}. a sauvegardé la croisière %{cruiseSailingName} partant le %{date} sur %{cruiseSailingLineName} pour réserver plus tard.",
    },
    navigatorCruiseRecommendation: {
      title: "Recommandation de croisière de @navigator.",
      body: "Voici une croisière qui correspond à vos intérêts!",
    },
    collaboratorJoinedTrip: {
      title: "Nouvelle personne a rejoint le voyage",
      body: "%{userFirstName} %{userLastNameInitial}. a rejoint %{tripName}.",
    },
    guestJoinedTripRoom: {
      title: "Un invité a rejoint la chambre",
      body: "%{guestFirstName} %{guestLastNameInitial}. a rejoint %{roomName}.",
    },
    guestLeavedTripRoom: {
      title: "Un invité a quitté la chambre",
      body: "%{guestFirstName} %{guestLastNameInitial}. a quitté %{roomName}.",
    },
    chatMessage: {
      title: "%{sender} a envoyé un message à %{tripName}",
    },
    userBookedCabin: {
      title: "Cabine réservée pour %{tripName}",
      body: "%{userFirstName} %{userLastNameInitial}. a réservé la cabine #%{cabinNo} au %{deckName}",
    },
    savedCruiseCabins: {
      title: "Cabine sauvegardée pour %{tripName}",
      body: "%{userFirstName} %{userLastNameInitial}. a sauvegardé la cabine #%{cabinNo} au %{deckName}",
    },
    tripUpdated: {
      title: "Voyage mis à jour",
      body: "%{from} a apporté des modifications au voyage, voici un résumé mis à jour 🛳️:",
    },
    tripCreated: {
      title: "Voyage créé",
      body: "%{from} vient de créer un nouveau voyage, voici un bref résumé 🛳️:",
    },
    loyaltyTokensEarn: {
      influencerInvitation: {
        title: "Points Cruisen gagnés",
        body: "Vous avez gagné %{loyaltyTokensEarned} points pour votre inscription!",
      },
      userJoined: {
        title: "Points Cruisen gagnés",
        body: "Vous avez gagné %{loyaltyTokensEarned} points pour votre inscription!",
      },
      userInvitation: {
        title: "Points Cruisen gagnés",
        body: "Vous avez gagné %{loyaltyTokensEarned} pour avoir invité %{invitedUserFirstName} %{invitedUserLastNameInitial}!",
      },
      booking: {
        title: "Nouveaux Points Cruisen",
        body: "Vous gagnerez %{loyaltyTokensEarned} points après votre croisière.",
      },
      manualBonus: {
        title: "Nouveaux Points Cruisen",
        body: "Vous avez gagné %{loyaltyTokensEarned} points en bonus.",
      },
    },
    loyaltyTokensUnlocked: {
      title: "Points Cruisen débloqués",
      body: "Vous avez maintenant %{loyaltyTokensUnlocked} points disponibles après votre croisière.",
    },
    priceDrop: {
      title: "Le prix de la croisière a baissé",
      body: "Le prix de %{cruiseSailingName} est maintenant de %{newPricePP} par personne, il était de %{oldPricePP}. Consultez les nouvelles offres pour %{resultsWithPriceDropCounter} croisières",
      ctaButtonText: "Voir les croisières",
    },
  },
  errors: {
    tryAgainLater: "Veuillez réessayer plus tard ou contacter l'équipe de support.",
    updatingAccount:
      "Oups! Nous rencontrons actuellement des problèmes pour mettre à jour le compte, veuillez réessayer plus tard.",
    loyaltyProgram: "Oups! Nous rencontrons actuellement des problèmes avec les Points Cruisen.",
    rooms: "Oups! Nous rencontrons actuellement des problèmes pour obtenir les chambres.",
    trip: "Oups! Nous rencontrons actuellement des problèmes pour obtenir le voyage.",
    createTrip: "Oups! Nous rencontrons actuellement des problèmes pour créer le voyage.",
    updateTrip: "Oups! Nous rencontrons actuellement des problèmes pour mettre à jour le voyage.",
    tripData:
      "Oups! Nous rencontrons actuellement des problèmes pour obtenir les données du voyage.",
    userTrips: "Oups! Nous rencontrons actuellement des problèmes pour obtenir vos voyages.",
    invitation: "Oups! Nous rencontrons actuellement des problèmes avec l'invitation.",
    navigator: "Oups! Nous rencontrons actuellement des problèmes avec Navigator.",
    profile: "Oups! Nous rencontrons actuellement des problèmes avec les profils.",
    billing: "Oups! Nous rencontrons actuellement des problèmes avec la facturation.",
    booking: "Oups! Nous rencontrons actuellement des problèmes avec la réservation.",
    cruiseLines:
      "Oups! Nous rencontrons actuellement des problèmes avec les compagnies de croisière.",
  },
}

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>
    }
  : T

export default frCA
export type Translations = typeof frCA
export type PartialTranslations = DeepPartial<typeof frCA>
